module.exports = __webpack_public_path__ + "static/media/hyper-4.fcb9af74.PNG";